import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 14l11 -11","key":"svg-0"}],["path",{"d":"M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5","key":"svg-1"}]]

/**
 * IconSend
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2VuZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTAgMTRsMTEgLTExIiAvPgogIDxwYXRoIGQ9Ik0yMSAzbC02LjUgMThhLjU1IC41NSAwIDAgMSAtMSAwbC0zLjUgLTdsLTcgLTMuNWEuNTUgLjU1IDAgMCAxIDAgLTFsMTggLTYuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/send
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSend = createReactComponent('outline', 'send', 'Send', __iconNode);

export default IconSend;